export default "__VITE_ASSET__dff9fd9f__"